import NumberFormatTextField from "../components/misc/NumberFormatTextField";
import FloatFormatTextField from "../components/misc/FloatFormatTextField";
import { TextField } from "formik-material-ui";

export function getFieldType(type) {
  switch (type) {
    case "num":
      return NumberFormatTextField;
    case "float":
      return FloatFormatTextField;
    default:
      return TextField;
  }
}
